module.exports = __webpack_public_path__ + "img/cp-outlined-fish-1.5f138ab1.svg";